var map = {
	"./title_en.png": "vtPM",
	"./title_fr.png": "RnfK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1W2q";


//////////////////
// WEBPACK FOOTER
// ./src/components/loader/img ^\.\/title_.*\.png$
// module id = 1W2q
// module chunks = 0